import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';
import errorImage from '../../../../../../../assets/illustrations/error-files.svg';

interface IProps {
  handlerClose: () => void;
  show: boolean;
}

const ErrorProcess = ({ handlerClose, show }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Aceptar"
    handlerButtonA={() => handlerClose()}
    img={errorImage}
  >
    <DialogExtraCaption
      // subtitle="Parece que ha ocurrido un error"
      subtitle={
        <>
          Parece que ha ocurrido un error
          <br />
          <br />
          *Si el problema persiste, por favor comunícate con nosotros:
          <br />
          <b>0801 19600</b> o <b>315 9600</b>
        </>
      }
      title="¡Oh no!"
    />
  </Dialog>
);

export default ErrorProcess;
